module.exports = __webpack_public_path__ + "static/img/7368996914.8e46a1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/7368996914.jpg
// module id = wncs
// module chunks = 1